import { Urs, UrsActionType } from "./UrsSlice"
import { Box, Button, Paper, Stack, Typography } from "@mui/material"
import { Localized } from "@fluent/react"

interface ImportedUrsDetailsPanelProps {
    entity: Urs,
    editable: boolean,
    isUrsLinkAvail: (action: UrsActionType, urs: Urs) => boolean;
    handleEditUrsNumber: () => void;
    handleEditSimpleDescriptionFieldClick: (field: 'purpose' | 'description' | 'area' | 'title', value: string) => void;
    handleEditDescriptionFieldClick: (field: 'purpose' | 'description' | 'area', value: string) => void;
}

export const ImportedUrsDetailsPanel = ({
    entity,
    editable,
    isUrsLinkAvail,
    handleEditUrsNumber,
    handleEditSimpleDescriptionFieldClick,
    handleEditDescriptionFieldClick }: ImportedUrsDetailsPanelProps) => {

    return (

        <Stack direction="column" spacing={2}>
            {[
                {
                    id: "document-number",
                    label: "Numer dokumentu",
                    content: entity.ursNo || "Brak ...",
                    editable: true,
                    editAction: handleEditUrsNumber,
                },
                {
                    id: "urs-title",
                    label: "Tytuł dokumentu",
                    content: entity.title || "Brak tytułu...",
                    editable: true,
                    editAction: () =>
                        handleEditSimpleDescriptionFieldClick("title", entity.title || ""),
                },
                {
                    id: "urs-description",
                    label: "Opis",
                    content: <div dangerouslySetInnerHTML={{ __html: entity.description || "" }} />,
                    editable: editable,
                    editAction: () =>
                        handleEditDescriptionFieldClick("description", entity.description || ""),
                },
            ].map(({ id, label, content, editable, editAction }) => (
                <Paper
                    key={id}
                    elevation={2}
                    sx={{
                        padding: 2,
                        borderRadius: 2,
                        backgroundColor: "background.paper",
                        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <Typography variant="subtitle2" gutterBottom>
                        <Localized id={id}>
                            <span>{label}</span>
                        </Localized>
                    </Typography>
                    <Box
                        sx={{
                            padding: 1,
                            marginLeft: 2,
                            borderRadius: 1,
                            backgroundColor: "grey.100",
                        }}
                    >
                        <Typography variant="body1">{content}</Typography>
                    </Box>
                    {editable && (
                        <Button
                            variant="text"
                            size="small"
                            onClick={editAction}
                            sx={{ marginTop: 1 }}
                        >
                            <Localized id="edit" />
                        </Button>
                    )}
                </Paper>
            ))}
        </Stack>
    );
}
